module.exports = __webpack_public_path__ + "static/img/naniungo-2.b7361dca.jpg";